import React from 'react';
import Modal from '../procedures/components/Modal/Modal';
import ContentModalOneButton from '../procedures/components/ContentModalOneButton';

interface WaitingListModalsProps {
  isRegisteredWaitingList: boolean;
  clearRegisterWaitingList: () => void;
  showWarningWaitingListModal: boolean;
  clearRegisterWaitingListWhenError: () => void;
  errorWarningWaitingListMessage: string;
  iconWarning: string;
  waitingListTitle?: string;
}

const WaitingListModals: React.FC<WaitingListModalsProps> = ({
  isRegisteredWaitingList,
  clearRegisterWaitingList,
  showWarningWaitingListModal,
  clearRegisterWaitingListWhenError,
  errorWarningWaitingListMessage,
  iconWarning,
  waitingListTitle
}) => (
  <>
    <Modal
      show={isRegisteredWaitingList}
      handleClose={clearRegisterWaitingList}
    >
      <ContentModalOneButton
        img={null}
        title={
          waitingListTitle || '¡Estás en lista de espera para este evento!'
        }
        subtitle={
          <>
            Cuando hayan vacantes disponibles, te avisaremos a tu correo UTP.
            <br />
            Tendrás 24 horas para inscribirte.
          </>
        }
        showInfo={false}
        textButton="Entendido"
        onClickButton={clearRegisterWaitingList}
      />
    </Modal>
    <Modal
      show={showWarningWaitingListModal}
      handleClose={clearRegisterWaitingListWhenError}
    >
      <ContentModalOneButton
        img={iconWarning}
        title={errorWarningWaitingListMessage}
        showInfo={false}
        textButton="Entendido"
        style={{ textAlign: 'center' }}
        onClickButton={clearRegisterWaitingListWhenError}
      />
    </Modal>
  </>
);

export default WaitingListModals;
